import 'isomorphic-fetch'
import { getApiBaseUrlWithOrg, getApiHeaders, checkHttpStatus } from '../utils'
import { basicGet } from '../utils/api'

export const FETCH_QUEST_SKILLS_REQUEST = 'FETCH_QUEST_SKILLS_REQUEST'
export const FETCH_QUEST_SKILLS_SUCCESS = 'FETCH_QUEST_SKILLS_SUCCESS'
export const ADD_QUEST_SKILL_SUCCESS = 'ADD_QUEST_SKILL_SUCCESS'
export const DELETE_QUEST_SKILL_SUCCESS = 'DELETE_QUEST_SKILL_SUCCESS'

export function fetchQuestSkillsRequest() {
  return {
    type: FETCH_QUEST_SKILLS_REQUEST
  }
}

export function fetchQuestSkillsSuccess(skills) {
  return {
    type: FETCH_QUEST_SKILLS_SUCCESS,
    payload: {
      skills
    }
  }
}

export function addQuestSkillSuccess(skill) {
  return {
    type: ADD_QUEST_SKILL_SUCCESS,
    payload: {
      skill
    }
  }
}

export function deleteQuestSkillSuccess(skillId) {
  return {
    type: DELETE_QUEST_SKILL_SUCCESS,
    payload: {
      skillId
    }
  }
}

export function fetchQuestSkills() {
  return async (dispatch, getState) => {
    const state = getState()
    const orgId = state.organization.orgId
    const questId = state.quest.item.id
    const url = `${getApiBaseUrlWithOrg(
      orgId
    )}/quests/${questId}/framework_skills`

    return basicGet(
      state,
      dispatch,
      url,
      fetchQuestSkillsRequest,
      fetchQuestSkillsSuccess
    )
  }
}

export function addQuestSkill(skillId) {
  return async (dispatch, getState) => {
    const state = getState()
    const questId = state.quest.item.id
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/framework_skills`

    try {
      const response = checkHttpStatus(
        await fetch(url, {
          method: 'POST',
          headers: getApiHeaders(state),
          body: JSON.stringify({
            quest_framework_skill: {
              framework_skill_id: skillId
            }
          })
        })
      )
      const json = await response.json()
      dispatch(addQuestSkillSuccess(json))
    } catch (error) {
      console.log(error)
    }
  }
}

export function deleteQuestSkill(skillId) {
  return async (dispatch, getState) => {
    const state = getState()
    const questId = state.quest.item.id
    const url = `${getApiBaseUrlWithOrg(
      state.organization.orgId
    )}/quests/${questId}/framework_skills/${skillId}`
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'DELETE',
          headers: getApiHeaders(state)
        })
      )
      dispatch(deleteQuestSkillSuccess(skillId))
    } catch (error) {
      console.log(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/questskills.js